import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as selectors from '../../reducers';
import styles from './region-page.module.scss';
import RegionMap from '../../components/region-map';
import { setActiveRegion, setActivePage, setActiveDam } from '../../actions/ui';
import scrollToComponent from '../../helpers/scroll-to-component';
import { RegionTable } from '../../components/region-table';
import { DamInfo } from '../../components/dam-info/dam-info';
import Select from 'react-select';

const ActiveDamMarker = (props) => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.4737 5.58317C11.4737 8.22954 6.24565 13.2498 6.24565 13.2498C6.24565 13.2498 1.01758 8.22954 1.01758 5.58317C1.01758 2.93681 3.35826 0.791504 6.24565 0.791504C9.13303 0.791504 11.4737 2.93681 11.4737 5.58317Z"
      fill="white"
      stroke="#E98D67"
    />
  </svg>
);

class RegionPage extends Component {
  constructor(props) {
    super();
    this.damInfo = null;
    this.selectRegion = this.selectRegion.bind(this);
    this.selectDam = this.selectDam.bind(this);
    this.goToSearch = this.goToSearch.bind(this);
  }

  componentDidMount() {
    const { damsInActiveCouncil, activeDam } = this.props;
    if (!activeDam && damsInActiveCouncil && damsInActiveCouncil.length > 0) {
      this.selectDam(this.props.damsInActiveCouncil[0].dam);
    }
  }

  componentDidUpdate(prevProps) {
    const { damsInActiveCouncil, activeCouncil } = this.props;
    if (prevProps.activeCouncil.id !== activeCouncil.id) {
      if (damsInActiveCouncil && damsInActiveCouncil.length > 0) {
        this.selectDam(this.props.damsInActiveCouncil[0].dam);
      }
    }
  }

  goToSearch() {
    const { setActivePage, setActiveRegion, setActiveDam } = this.props;
    setActivePage('search');
    setActiveRegion(null);
    setActiveDam(null);
  }

  selectRegion(regionId) {
    const { setActiveRegion } = this.props;
    setActiveRegion(regionId);
  }

  selectDam(dam) {
    const { setActiveDam } = this.props;
    setActiveDam(dam);
    const element = this.damInfo;
    scrollToComponent(element);
  }

  renderMaps() {
    const { activeCouncil, activeDam } = this.props;
    return (
      <div className={`${styles.mapsRow}`}>
        <RegionMap
          council={activeCouncil}
          onCouncilSelect={this.selectRegion}
          onDamSelect={this.selectDam}
          activeDam={activeDam}
        />
      </div>
    );
  }

  renderRegionTable() {
    const { activeCouncil, damsInActiveCouncil } = this.props;
    return (
      <div className={styles.regionTableArea}>
        <RegionTable region={activeCouncil} dams={damsInActiveCouncil} />
      </div>
    );
  }

  renderDamInfo() {
    const { damsInActiveCouncil, activeDam } = this.props;
    if (!damsInActiveCouncil || damsInActiveCouncil.length === 0 || !activeDam)
      return null;

    return (
      <div className={styles.regionTableArea} ref={(el) => (this.damInfo = el)}>
        <div className={styles.areaTitle}>Select a dam</div>
        <div className={styles.damDropdownContainer}>
          <ActiveDamMarker style={{ height: 30, width: 30, marginRight: 10 }} />
          <div className={styles.damDropdown}>
            <Select
              name="damDropdown"
              value={{ value: activeDam.dam, label: activeDam.dam }}
              onChange={(x) => {
                this.selectDam(x.value);
              }}
              options={damsInActiveCouncil.map((x) => ({
                value: x.dam,
                label: x.dam,
              }))}
              clearable={false}
              isDisabled={damsInActiveCouncil.length === 1}
            />
          </div>
        </div>
        {activeDam && (
          <small style={{ marginBottom: 20, marginTop: 5, paddingLeft: 40 }}>
            Dam ID {activeDam.id}, owned by <strong>{activeDam.owner}</strong>
          </small>
        )}
        <DamInfo selectedDam={activeDam} dams={damsInActiveCouncil} />
      </div>
    );
  }

  render() {
    return (
      <div className={styles.councilPage}>
        <div className={styles.buttonsRow}>
          <button
            type="button"
            className={styles.backLink}
            onClick={this.goToSearch}
          >
            <img
              className={styles.backLinkImage}
              src={`${process.env.PUBLIC_URL}/img/chevron-icon.svg`}
              alt="chevron icon"
              style={{ width: 10, height: 10 }}
            />
            back to search
          </button>
        </div>
        {this.renderMaps()}
        {this.renderRegionTable()}
        <br />
        {this.renderDamInfo()}
      </div>
    );
  }
}

const mapDispatchToProps = {
  setActiveRegion,
  setActivePage,
  setActiveDam,
};

const mapStateToProps = (state) => ({
  activeCouncil: selectors.getActiveCouncil(state),
  activeDam: selectors.getActiveDam(state),
  councils: selectors.getCouncils(state),
  damsInActiveCouncil: selectors.getDamsByRegion(state),
});

RegionPage.propTypes = {
  councils: PropTypes.arrayOf(PropTypes.object),
  damsInActiveCouncil: PropTypes.arrayOf(PropTypes.object),
  setActiveRegion: PropTypes.func,
  activeCouncil: PropTypes.object.isRequired,
  activeDam: PropTypes.object,
  setActiveDam: PropTypes.func,
  setActivePage: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegionPage);



// WEBPACK FOOTER //
// ./src/pages/region-page/region-page.js